<template>
	<div>
		<v-container fluid grid-list-md>
			<v-layout row wrap>
           <v-flex xs12>
                <v-snackbar
                    v-model="alert" 
                    color="green lighten-2" 
                    class="white--text" 
                    top outlined dense 
                    type="success" text>
                    {{ message }}
                    <v-btn color="white"  text  @click="alert = false">  <v-icon color="maroon">mdi-close</v-icon></v-btn>
                </v-snackbar>
                 <v-snackbar
                    v-model="alert_error" 
                    color="red lighten-2" 
                    class="white--text" 
                    top outlined dense
                    type="error" text>
                    {{ error }}
                    <v-btn color="white"  text  @click="alert_error = false"> Close</v-btn>
                </v-snackbar>
           </v-flex>
			</v-layout>
			<v-layout row wrap >
				<v-flex xs12 sm8 md6 offset-md-3 offset-sm-2>
					<v-card style="position: relative" class="text-xs-center padding-6 mt-1">
						<v-img 
			              :src="require('../assets/images/marathon_icon.png')"
			              width="250" 
			              height="auto"
			              style="margin: 0 auto;">
			            </v-img>
			            <v-card-title primary-title>
			              	<v-flex xs12>
                  				<h4 class="text-center">Welcome to Visitor Management</h4>
              				</v-flex>
			            </v-card-title>
                        

			            <v-form id="login" 
                                @submit.prevent="validateBeforeSubmit" 
                                data-vv-scope="login" 
                                ref="login" 
                                v-model="valid">
			            	<v-card-text>
			            	<v-layout row wrap>
			              		<v-flex xs12 sm12>			               			            				    
			              			<v-text-field
			              		  	name="Username"
			              		  	label="Username"
			              		  	v-model="username"
									:rules="[(v) => !!v || 'Username is required']"
			              		  	id="username"
									@click=clearall()
									:error-messages="errors.collect('login.Username')"
									required
			              			></v-text-field>          			            		
			              		</v-flex>
			              		<v-flex xs12 sm12>			               			            				     
			              		  	<v-text-field
			              		  	name="Password"
			              		  	label="Password"
			              		  	v-model="password"
									:error-messages="errors.collect('login.Password')"
			              		  	:append-icon="e1 ? 'visibility' : 'visibility_off'"
                    				@click:append="() => (e1 = !e1)"
                    				:type="e1 ? 'password' : 'text'"
									:rules="[(v) => !!v || 'Password is required']"
			              		  	id="password"
			              		  	required
			              		></v-text-field>          			            		
			              		</v-flex>
			           		</v-layout>	
			           		</v-card-text>
			           		<v-card-actions class="justify-center">
            					<v-btn type="submit" color="primary" :loading="loading" :disabled="loading">Login</v-btn>
          					</v-card-actions>		           			              
			            </v-form>			            
					</v-card>
				</v-flex>
			</v-layout>
		</v-container>
	</div>
</template>
<script>


import firebase, { messaging } from 'firebase';
export default {
	
	methods:{

		async getTokenAsync(){
				
				 const messaging = firebase.messaging();
				 await messaging.requestPermission();
				 try {
						this.firebase_token = await messaging.getToken();
						if (this.firebase_token) {
							
							await this.sendTokenToServerAsync(this.firebase_token);
							//console.log(this.firebase_token);
							return this.firebase_token;						
						}
						else {
							console.log('No Instance ID token available. Request permission to generate one.');
							return false;
						}
					} catch (err) {
						console.log('An error occurred while retrieving token. ', err);
						return false;
				} 
				
		},

	 login()
		{
			this.loading = true;
			this.firebase_token = localStorage.getItem('Mvm_firebase_token'); 	  
			   if(this.firebase_token==null)
				{ 
				    //this.getTokenAsync()		
				}
			
			var data = {
				username: this.username,
				password: this.password,
				token: this.firebase_token
			};

     		axios
			.post(`${process.env.VUE_APP_API_URL}/api/login`, data)
        	.then(response => { 
        		if (response.data.status == 1) {
					this.error = response.data.message;
					var registrationTokens = '';
                    var topic = response.data.id;
        			this.$store.dispatch('storeAccessToken', response.data.access_token);
					this.$store.dispatch('storeUser', response.data.user,)
					
            		.then(()=>{
						localStorage.setItem("visitor_management_firebase_token", this.firebase_token);
            			localStorage.setItem("visitor_management_access_token", response.data.access_token);
						localStorage.setItem("visitor_management_expiration", response.data.expiration);
						localStorage.setItem("visitor_management_user",JSON.stringify(response.data.user));
						localStorage.setItem("visitor_management_role", response.data.role);
						axios.defaults.headers.common['Authorization'] = 'Bearer ' + this.$store.getters.get_access_token;
                		this.loading = false;
                		this.$router.push('/');
					});

				
        		}
        		else{
					this.alert_error=true;
        			this.error = response.data.message;
        		}
        	})
        	.catch(error => {
				  console.log(error);
				  if (!error.response) {
					  this.alert_error=true;
				      this.error ="Error Occured While Establishing Connection.";
				  }
        	})
        	.finally(() => {
          		this.loading = false;
        	});
		},
		validateBeforeSubmit() {
            this.$validator.validateAll().then(result => {
                if (result) {
                   this.login();
				}
				return false;
            });
        },
		clearall(){
			this.error=' '
	
		},
		async sendTokenToServerAsync(firebase_token) {

                var data={token:this.firebase_token}

                axios.post(`${process.env.VUE_APP_API_URL}/api/notification/suscribeTokenToTopic`,data).then((response) => {
                if (response.data.status == 1) {
					return true;
                }  
                  }).catch((error) => {
                      console.log(error);
                  }).finally(() => {

                  });
        }
       
	},
	data(){
		return{
			is_loading: false,
			  username: "",
			  valid:false,
     		password: "",
			 error:'',
			 message:'',
      		formErrors: {},
      		loader:null,
			loading: false,
			 firebase_token:"",
			e1: true,
			 alert: false,
            alert_error:false
		}
	},
	mounted(){
		 if(localStorage.getItem('Mvm_access_token') == null) {
			 
		  }
	}
	
};
</script>
<style scoped>
.v-card:not(.v-sheet--tile):not(.v-card--shaped) {
    border-radius: 4px;
    padding: 4% 6% 4% 6%;
}
.mt-10{
	margin-top:20%;
}
.v-application .info {
    background-color: #82b1ff1f !important;
    border-color: #2196f3 !important;
    text-align: center;
    font-size: 16px;
    color: darkred;
}

</style>